import axios from 'axios';
import { API_TIMEOUT, API_MAX_RETRIES, API_RETRY_DELAY } from '../containers/constants';
import { API_ERROR_URL } from '../containers/APIurls';

const sleep = (time) => {
  return new Promise((resolve) => setTimeout(resolve, time));
}

const getClient = (baseUrl = null) => {

  const options = {
    baseURL: baseUrl,
    timeout: API_TIMEOUT,
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0' // For older HTTP/1.0 proxies
  };

  const client = axios.create(options);
  const safeStringify = require('fast-safe-stringify');
  const max_retries = API_MAX_RETRIES;
  const retry_delay = API_RETRY_DELAY;
  let counter = 0;

  // Add a request interceptor
  client.interceptors.request.use(
    (requestConfig) => {
      console.debug(`making request: ${safeStringify(requestConfig)}`);
      return requestConfig;
    },
    (requestError) => {
      // Do something with error
      console.error(requestError);
      return Promise.reject(requestError);
    },
  );

  // Add a response interceptor
  client.interceptors.response.use(
    async (response) => {
      // Do something with response
      // console.debug(`Response success: ${safeStringify(response)}`);
      if (response?.data?.ErrorMessage == "Timeout") {
        const config = response.config;
        if (counter < max_retries) {
          let res = null;
          counter++; 
          res = await sleep(retry_delay).then( async () => {
            return await new Promise( async (resolve) => {
               resolve(client(config));
            })
          });
          if(res && res.data) {
            return  Promise.resolve(res);
          }
        }
        else{       
            return handleError(response);        
        }
      }else
      {
 return response;
      }
     
     
    },
    async (error) => {
      // Any status codes that fall outside the range of 2xx cause this function to trigger
      // retry the request for certain errors
      if (isRetryable(error?.response?.status)) {
        const config = error.config;
        if (counter < max_retries) {
          let res = null;
          counter++; 
          res = await sleep(retry_delay).then( async () => {
            return await new Promise( async (resolve) => {
               resolve(client(config));
            })
          });
          if(res && res.data) {
            return  Promise.resolve(res);
          }
        } else {
            return handleError(error);
        }
      }  else {
        return handleError(error);
      }
      // Do something with response error
     
    },
  );

  return client;
};

function handleError(error) {
  let errJson;
  const safeStringify = require('fast-safe-stringify');
  try{
    errJson = error.toJSON();
  } catch (err) {
    errJson ={message: "Something went wrong. Please try again", config: {url: error?.config?.url || ""}}
  } 
  console.debug(safeStringify(errJson));
  const requestDt = { message: errJson?.message, url: errJson?.config?.url }
  axios.post(API_ERROR_URL, safeStringify(requestDt));
  console.error(`Response error: ${error}`);
  return Promise.reject(error);
}

const isRetryable = (httpErrorCode) => {
  return !httpErrorCode || httpErrorCode === 408 || httpErrorCode >= 500
}

class ApiClient {
  constructor(baseUrl = null) {
    this.client = getClient(baseUrl);
  }

  async get(url, conf = {}) {
    try {
      const response = await this.client.get(url, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  }

  async delete(url, conf = {}) {
    try {
      const response = await this.client.delete(url, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  }

  async head(url, conf = {}) {
    try {
      const response = await this.client.head(url, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  }

  async options(url, conf = {}) {
    try {
      const response = await this.client.options(url, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  }

  async post(url, data = {}, conf = {}) {
    try {
      const response = await this.client.post(url, data, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  }

  async put(url, data = {}, conf = {}) {
    try {
      const response = await this.client.put(url, data, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  }

  async patch(url, data = {}, conf = {}) {
    try {
      const response = await this.client.patch(url, data, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  }
}

export { ApiClient };

/**
 * Base HTTP Client
 */
export default {
  // Provide request methods with the default base_url
  async get(url, conf = {}) {
    try {
      const response = await getClient().get(url, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  },

  async delete(url, conf = {}) {
    try {
      const response = await getClient().delete(url, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  },

  async head(url, conf = {}) {
    try {
      const response = await getClient().head(url, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  },

  async options(url, conf = {}) {
    try {
      const response = await getClient().options(url, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  },

  async post(url, data = {}, conf = {}) {
    try {
      const response = await getClient().post(url, data, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  },

  async put(url, data = {}, conf = {}) {
    try {
      const response = await getClient().put(url, data, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  },

  async patch(url, data = {}, conf = {}) {
    try {
      const response = await getClient().patch(url, data, conf);
      return await Promise.resolve(response);
    }
    catch (error) {
      return await Promise.reject(error);
    }
  },

  asyncPost(url, data = {}, conf = {}) {
    try {
      getClient().post(url, data, conf);
    }
    catch (error) {
      // return await Promise.reject(error);
    }
  },

};